module.exports = __webpack_public_path__ + "img/lymphomap_logo.fa717734.png";